import { Module } from "src/state/Module"
import * as Types from "src/state/gql/_types"

export const GuidelineModule = new Module<Types.GuidelineFragment, Types.GetGuidelinesQueryVariables, Types.Guidelines_Insert_Input>({
    sortKey: 'created_at',
})